import React, { FunctionComponent } from 'react';

import { features } from 'components/lexemes';
import { TrackingLink } from 'lib/app/tracking-link';
import { CdnImagePath } from 'lib/cdn-image-path';

import { onClickAboutCTA } from 'containers/events';

import PageSectionCta from 'components/page/sections/page-section-cta';

export const ComplimentsBlockThreeContainer: FunctionComponent = () => {
  const props = {
    imagePosition: 'left',
    imageSrc: `${CdnImagePath}/landing/assets/illustrations/features/compliments/feature-compliments.svg`,
    imageObjectPosition: '33% 31%',
    imageAlt: '',
    title: features.compliments.lxComplimentsThreeBlockTitle,
    text: features.compliments.lxComplimentsThreeBlockSubtitle,
    actionText: features.compliments.lxFeaturesDownloadBumbleCta,
    actionUrl: TrackingLink.APPSFLYER_LINK,
  };

  return (
    <PageSectionCta
      title={props.title}
      /**
       * Fix language based code
       */
      // titleLang={'en'}
      text={props.text}
      action={{
        text: props.actionText,
        href: props.actionUrl,
        onClick: onClickAboutCTA,
      }}
      image={{
        src: props.imageSrc,
        objectPosition: props.imageObjectPosition,
        inlinePosition: 'start',
      }}
      color="yellow"
    />
  );
};
